enum VaccineState {
    IsImmune,
    NotImmune,
    Discussed,
    Declined,
    Received
}

export { VaccineState };
